<template>
  <div class="card shadow-sm" style="max-width: 25rem; min-width: 18rem">
    <div class="card-header mx-0 px-3 shadow-sm border-bottom-0 d-flex align-items-center">
      <h5 class="fw-bold ms-2 mb-0 flex-grow-1">Product Offerings</h5>
      <IconButton
        id="create-product-offering"
        icon-name="material-symbols:add"
        class="text-success"
        @keypress.stop
        @click.stop="goToProductOfferingForm"
      />
    </div>
    <ListGroup :loading="loading" :default-active-id="''">
      <ListGroupItem
        v-for="offering in product.offerings"
        :key="offering.sku"
        :list-id="offering.sku"
        :name="offering.name"
      >
        <template #actions>
          <ProductOfferingIconButtonGroup
            @update="updateOffering(offering.id)"
            @delete="openDeleteDialog(offering.id)"
          />
        </template>
      </ListGroupItem>
    </ListGroup>
    <DeleteDialog
      :open="isDeleteDialogOpen"
      type="product"
      @delete="deleteProductOffering"
      @close="isDeleteDialogOpen = false"
    />
  </div>
</template>
<script lang="ts" setup>
defineProps<{
  loading: boolean;
  product: Product;
}>();

const emit = defineEmits<{
  'delete:offering': [value: number];
}>();

const router = useRouter();
const route = useRoute();

// Stores
const productsStore = useProductsStore();

const goToProductOfferingForm = () => {
  // Necessary to circumvent :corePath+ router history.
  const path = route.path.replace('/update/', '/create/');
  router.push({path, query: {po: 1}});
};

const updateOffering = (id: string | number) => {
  router.push({
    path: `${id}`,
    query: {po: 1},
  });
};

const isDeleteDialogOpen = ref(false);
const idToDelete = ref(0);
const openDeleteDialog = (id: number) => {
  isDeleteDialogOpen.value = true;
  idToDelete.value = id;
};

const deleteProductOffering = async () => {
  try {
    productsStore.deleteProductOffering(idToDelete.value);
    emit('delete:offering', idToDelete.value);
  } catch (errorMessage) {
    console.log(errorMessage);
  } finally {
    isDeleteDialogOpen.value = false;
  }
};
</script>
<style lang="scss" scoped>
:deep(.list-group-item) > .btn-group {
  transition: all 0.2s ease-out;
  opacity: 0;
}

:deep(.list-group-item:hover) > .btn-group {
  opacity: 1;
}
</style>
